import { render } from "./DotNet.vue?vue&type=template&id=a55ea114&scoped=true"
import script from "./DotNet.vue?vue&type=script&lang=js"
export * from "./DotNet.vue?vue&type=script&lang=js"

import "./DotNet.vue?vue&type=style&index=0&id=a55ea114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55ea114"]])

export default __exports__